var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DrawerNorth from "./drawerNorth";
import DrawerWest from "./drawerWest";
import DrawerSouth from "./drawerSouth";
import DrawerEast from "./drawerEast";
import Docks from "../docks";
export default function Drawers() {
    return (_jsxs("section", __assign({ className: "relative flex flex-row flex-auto overflow-hidden z-30" }, { children: [_jsx(DrawerWest, {}), _jsxs("div", __assign({ className: "relative flex flex-col flex-auto overflow-hidden" }, { children: [_jsx(DrawerNorth, {}), _jsx(Docks, {}), _jsx(DrawerSouth, {})] })), _jsx(DrawerEast, {})] })));
}
